import React from "react";
import { AlertTriangle, Info } from "lucide-react";

const th = { textAlign: "left", padding: "8px 10px", fontSize: 10, letterSpacing: "0.16em", textTransform: "uppercase", color: "#737373", fontWeight: 700 };
const td = { padding: "9px 10px", borderTop: "1px solid rgba(255,255,255,0.06)", fontSize: 14, fontVariantNumeric: "tabular-nums" };
const LEVEL = { high: "#f87171", medium: "#facc15", info: "#a3a3a3" };
const g = (v) => (v === null || v === undefined ? "—" : `${v} g`);

export const MacroTable = ({ rows, testid = "macro-table", renderKcal }) => (
  <div style={{ overflowX: "auto" }}>
    <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 520 }} data-testid={testid}>
      <thead><tr><th style={th}>Tipo de día</th><th style={th}>Calorías</th><th style={th}>Proteínas</th><th style={th}>Grasas</th><th style={th}>Carbohidratos</th></tr></thead>
      <tbody>
        {rows.map((t) => (
          <tr key={t.key} data-testid={`${testid}-row-${t.key}`}>
            <td style={{ ...td, fontWeight: 600 }}>{t.label}</td>
            <td style={{ ...td, fontWeight: 800 }} data-testid={`${testid}-kcal-${t.key}`}>{renderKcal ? renderKcal(t) : (t.kcal ? `${t.kcal} kcal` : "—")}</td>
            <td style={td} data-testid={`${testid}-protein-${t.key}`}>{g(t.protein_g)}</td>
            <td style={td} data-testid={`${testid}-fat-${t.key}`}>{g(t.fat_g)}</td>
            <td style={{ ...td, color: t.carbs_g < 0 ? "#f87171" : undefined }} data-testid={`${testid}-carbs-${t.key}`}>{g(t.carbs_g)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const NutritionAlerts = ({ alerts, testid = "nutri-alerts" }) => (
  <div data-testid={testid}>
    {alerts.length === 0 ? <div style={{ fontSize: 13, color: "#4ade80" }}>Sin alertas.</div> : alerts.map((a, i) => (
      <div key={i} style={{ display: "flex", gap: 8, color: LEVEL[a.level], fontSize: 13, padding: "4px 0" }} data-testid={`${testid}-${i}`}>
        {a.level === "info" ? <Info size={14} style={{ flexShrink: 0, marginTop: 2 }} /> : <AlertTriangle size={14} style={{ flexShrink: 0, marginTop: 2 }} />}<span>{a.text}</span>
      </div>
    ))}
  </div>
);

export const WEEKDAYS = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];
export const DISCLAIMER = "Orientación deportiva general. No es una dieta médica ni un tratamiento clínico.";
